export default function ComparisonTable({ title, headers, rows }) {
  return (
    <div className="my-8">
      {title && (
        <h4 className="text-lg font-semibold mb-4 text-gold">{title}</h4>
      )}
      <div className="overflow-x-auto">
        <table className="w-full border border-white/10">
          <thead>
            <tr className="bg-white/5">
              {headers.map((header, idx) => (
                <th key={idx} className="px-4 py-3 text-left text-sm uppercase tracking-wide text-gold font-semibold border-b border-white/10">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIdx) => (
              <tr key={rowIdx} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                {row.map((cell, cellIdx) => (
                  <td key={cellIdx} className="px-4 py-3 text-white/70">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
